import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AssignToIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 19L21 16.5L18.5 14M21 16.5H15M14.5 20.648C13.71 20.877 12.87 21 12 21C7.03 21 3 16.971 3 12C3 7.029 7.03 3 12 3C16.63 3 20.45 6.5 20.95 11M5.98 18.695C6.53 17.405 7.81 16.5 9.3 16.5H10.98M15.6 9.75C15.6 11.738 13.99 13.35 12 13.35C10.01 13.35 8.4 11.738 8.4 9.75C8.4 7.762 10.01 6.15 12 6.15C13.99 6.15 15.6 7.762 15.6 9.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

AssignToIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AssignToIcon);
